import Vue from 'vue'

Vue.directive('cypress', {
  inserted(element, { value }) {
    element.setAttribute('data-cy', value)
  },
  update(element, { value }) {
    element.setAttribute('data-cy', value)
  }
})
